import React from 'react'

import  '@/css/global/cmscheckbox.scss'

const CmsCheckbox = ({isChecked, handleChange, labelText, id, labelHidden}: {isChecked: boolean, handleChange: (boolean?:boolean) => void, labelText:string, id: string, labelHidden?: boolean}) => {
    return ( 
    <div className='cms-checkbox-container'>
        <input
            id={id}
            type='checkbox'
            checked={isChecked}
            onChange={() => handleChange()}
        />
        <span className="checkmark" onClick={() => handleChange()} />
        <label className={`cms-checkbox-label ${labelHidden && 'sr-only'}`} htmlFor={id}>{labelText}</label>
    </div>)
}

export default CmsCheckbox